import React from "react";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Pokemon } from "./pokemon/pokemon";
import CVNew from "./components/cv-new/cv-new";
import LogoShowcase from "./components/logo-showcase/logo-showcase";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
const router = createBrowserRouter([
  {
    path: "/",
    element: <CVNew />,
  },
  {
    path: "/logos",
    element: <LogoShowcase />,
  },
  // {
  //   path: "/pokemon",
  //   element: <Pokemon />,
  // },
  // {
  //   path: "/cv",
  //   element: <CVNew />,
  // },
]);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// scp -r ./dist/* root@167.99.247.222:/var/www/mgraetz.de/html
